/**
 * Audio input plugin for Capacitor
 * Provides real-time audio capture with support for streaming and file recording
 */
/**
 * Audio source types enum for convenience
 */
export var AudioSourceType;
(function (AudioSourceType) {
    AudioSourceType[AudioSourceType["DEFAULT"] = 0] = "DEFAULT";
    AudioSourceType[AudioSourceType["MIC"] = 1] = "MIC";
    AudioSourceType[AudioSourceType["CAMCORDER"] = 5] = "CAMCORDER";
    AudioSourceType[AudioSourceType["VOICE_RECOGNITION"] = 6] = "VOICE_RECOGNITION";
    AudioSourceType[AudioSourceType["VOICE_COMMUNICATION"] = 7] = "VOICE_COMMUNICATION";
    AudioSourceType[AudioSourceType["UNPROCESSED"] = 9] = "UNPROCESSED";
})(AudioSourceType || (AudioSourceType = {}));
/**
 * Sample rates enum for convenience
 */
export var SampleRate;
(function (SampleRate) {
    SampleRate[SampleRate["TELEPHONE_8000Hz"] = 8000] = "TELEPHONE_8000Hz";
    SampleRate[SampleRate["CD_QUARTER_11025Hz"] = 11025] = "CD_QUARTER_11025Hz";
    SampleRate[SampleRate["VOIP_16000Hz"] = 16000] = "VOIP_16000Hz";
    SampleRate[SampleRate["CD_HALF_22050Hz"] = 22050] = "CD_HALF_22050Hz";
    SampleRate[SampleRate["MINI_DV_32000Hz"] = 32000] = "MINI_DV_32000Hz";
    SampleRate[SampleRate["CD_XA_37800Hz"] = 37800] = "CD_XA_37800Hz";
    SampleRate[SampleRate["NTSC_44056Hz"] = 44056] = "NTSC_44056Hz";
    SampleRate[SampleRate["CD_AUDIO_44100Hz"] = 44100] = "CD_AUDIO_44100Hz";
    SampleRate[SampleRate["DVD_AUDIO_48000Hz"] = 48000] = "DVD_AUDIO_48000Hz";
})(SampleRate || (SampleRate = {}));
